import RequestAbstract from "./RequestAbstract";

export default class AccountHistory extends RequestAbstract {
    get link() {
        return this.links.egisz;
    }

    async createDocument(visitId) {
        const req = await this.post(this.link + `/visit/${visitId}/create-document`);
        return req;
    }

    async updateStatus(visitId, status) {
        const req = await this.post(this.link + `/visit/${visitId}/egisz-status/${status}`);
        return req;
    }

    async signDocument(visitId, signQueue, operationId) {
        /*const data = {
            signQueue,
            certificateId
        };*/

        const data = {
            signQueue,
            operationId,
            pinCode: "12345678"
        };

        const req = await this.post(this.link + `/visit/${visitId}/sign-document`, data);
        return req;
    }

    async prepareSign(visitId, certificateId) {
        const data = {
            pinCode: "12345678",
            certificateId
        };

        const req = await this.post(this.link + `/visit/${visitId}/prepare-sign`, data);
        return req;
    }

    async listSignCertificates() {
        const req = await this.get(this.link + "/sign-certificates");
        return req;
    }

}
